<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row>
          <b-col class="mb-3">
            <h4>{{ $t('nav.label_sets_list_title') }}</h4>
          </b-col>
          <b-col md="auto">
            <b-button-group>
              <b-button :disabled="loading" v-if="list.actions && list.actions.create" class="mb-3" variant="primary"
                :to="{ name: 'LabelSetCreate' }">
                {{ $t('label_set.create_new') }}
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-input-group>
                <b-form-input :placeholder="$t('global.search')" v-model="filters.search"></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary" @click="getData()"><i class="fa fa-search" /></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="auto">
            <b-form-group label-cols :label="$dt('global.per_page', 'Per page:')">
              <b-form-select :options="[2, 10, 20, 50, 100, 500]" v-model="filters.per_page" />
            </b-form-group>
          </b-col>
          <b-col md="auto" v-if="listPaginator.last_page > 1">
            <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" />
          </b-col>
        </b-row>
        <div v-if="loading && !tableItems.length" class="text-center">
          <b-spinner type="grow" variant="primary" />
        </div>
        <NoDataView v-else-if="!tableItems.length" />
        <b-table v-else class="table-sm text-center" responsive outlined hover head-variant="light" :busy="loading"
          :no-local-sorting=true :sort-by.sync="filters.sort_field" :sort-desc.sync="filters.sort_order"
          :fields="tableFields" :items="tableItems" @row-clicked="rowClicked">
          <template v-slot:cell(data_type)="{ item }">
            {{ $t(`LabelSetType.${item.data_type}`) }}
          </template>
          <template v-slot:cell(created_at)="{ value }">{{ momentf(value) }}</template>
          <!-- <template v-slot:cell(label_set_tags)="row">
                  <template v-if="row.item.label_set_tags"><b-badge v-for="tag in row.item.label_set_tags" :key="tag.id" class="mx-1">{{tag.tag.name}}</b-badge></template>
                </template> -->
          <template v-slot:cell(sample_sets_data)="{ value, item }">
            <router-link v-for="sample_set in value" :key="`${item.id}-${sample_set.id}`"
              :to="{ name: 'Samples', params: { project_id: activeProjectId, sample_set_id: sample_set.id } }">
              <b-badge v-if="sample_set.actions.view" class="mx-1">
                {{ sample_set.id }}: {{ sample_set.name }}
              </b-badge>
            </router-link>
          </template>
          <template v-slot:cell(options)="row" @click.prevent>
            <div class="flex-container options-center">
              <router-link v-if="row.item.actions.view"
                :to="{ name: 'LabelSetSamples', params: { project_id: row.item.project_id, label_set_id: row.item.id } }">
                <a><i class="mx-1 fa fa-eye fa-lg" /></a>
              </router-link>
              <router-link v-if="row.item.actions.update"
                :to="{ name: 'LabelSetUpdate', params: { project_id: row.item.project_id, id: row.item.id } }">
                <a><i class="mx-1 fa fa-edit fa-lg" /></a>
              </router-link>
              <a href="" @click.prevent="" @click="downloadLabelSet(row.item.project_id, row.item.id)"><i
                  class="mx-1 fa fa-download fa-lg" /></a>
              <router-link v-if="row.item.actions.view" :to="{ name: 'LabelSetsCode' }">
                <a><i class="mx-1 fa fa-code fa-lg" /></a>
              </router-link>
              <Delete @click.native.stop v-if="row.item.actions.delete" :id="row.item.id" @deleted="getData"
                :deleteFn="() => deleteFn(row.item.project_id, row.item.id)" />
            </div>
          </template>
        </b-table>
        <b-row>
          <!--Paginator at bottom-->
          <b-col v-if="tableItems.length">
            <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" />
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import Pagination from 'laravel-vue-pagination';
import { mapGetters, mapActions, mapState } from 'vuex';
import NoDataView from '@/views/Shared/NoDataView.vue';
import Delete from '@/views/Shared/ModalDelete';
import Services from '@/services/index';

export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  data() {
    return {
      tableFields: [
        { key: 'id', sortable: true, label: this.$t('global.id') },
        {
          key: 'name', sortable: true, label: this.$t('label_set.name'), tdClass: 'text-left', thClass: 'text-left'
        },
        // { key: 'label_set_tags', sortable: true, label: this.$t('label_set.label_set_tags') },
        { key: 'data_type', sortable: true, label: this.$t('label_set.data_type') },
        {
          key: 'sample_sets_data', sortable: true, label: this.$dt('label_set.sample_sets', 'Sample sets'), tdClass: 'text-left', thClass: 'text-left'
        },
        { key: 'created_at', sortable: true, label: this.$t('global.created_at') },
        // { key: 'updated_at', sortable: true, label: this.$t('global.updated_at') },
        { key: 'options', label: this.$t('global.options') }
      ],
      filters: {
        sort_field: 'id',
        sort_order: true,
        search: '',
        per_page: 20,
      },
      loading: false,
      list: {},
    };
  },
  components: {
    Pagination, NoDataView, Delete
  },
  computed: {
    listPaginator() {
      return Object.is(this.list.meta, undefined) ? {} : this.list.meta;
    },
    tableItems() {
      return this.list.data || [];
    },
    params() {
      return {
        ...this.filters,
        page: this.page,
        sort_order: this.filters.sort_order ? 'desc' : 'asc'
      };
    },
    ...mapState('Auth', ['activeProjectId', 'token']),
  },
  watch: {
    page: 'getData',
    filters: { deep: true, handler: 'getData' },
  },
  methods: {
    getData() {
      this.loading = true;
      Services.labelSets.list(this.activeProjectId, this.params).then(({ data }) => {
        this.list = data;
        this.loading = false;
        if (!this.list.data?.length && this.page !== 1) {
          this.onPageChange(1);
        }
      }).catch((err) => {
        if (err.code !== 'ERR_CANCELED') {
          this.loading = false;
          console.log(err);
        }
      });
    },
    onPageChange(page) {
      page = page || this.page;
      if (page !== this.page) this.$router.push({ name: 'LabelSets', params: { page } });
    },
    deleteFn(projectId, id) {
      return Services.labelSets.delete(projectId, id);
    },
    downloadLabelSet(projectId, id) {
      window.location.href = `${window.location.origin}/api/project/${projectId}/label_sets/${id}/get_label_set?token=${this.token}`;
    },
    rowClicked(item) {
      this.$router.push({ name: 'LabelSetSamples', params: { project_id: item.project_id, label_set_id: item.id } });
    },
  }
};
</script>

<style scoped></style>
